module.exports = __webpack_public_path__ + "static/media/checkmark.20896b95.svg";